import { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import { Color3 } from '@babylonjs/core/Maths/math';
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { Scene } from '@babylonjs/core/scene';

export function createJoinGeometryVisualization(targetMesh: Mesh, scene: Scene, color?: Color3) {
    const visualization = targetMesh;

    if (!color) {
        color = Color3.Yellow();
    }

    const coloredMaterial = new StandardMaterial('', scene);
    //coloredMaterial.alpha = 0.5;
    coloredMaterial.wireframe = true;
    coloredMaterial.emissiveColor = color;
    visualization.material = coloredMaterial;
    return visualization;
}
